module.exports = __webpack_public_path__ + "static/img/8.a150c7c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/eng/8.png
// module id = k8KB
// module chunks = 0